import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Costanti, CostantiStorage } from './../costanti';

@Injectable()
export class JWTResponseInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      map((event: HttpEvent<any>) => {
        return event;
      }),
      catchError(err => {
        if (err instanceof HttpErrorResponse) {
          const isNppApiRequest = req.url.indexOf(Costanti.NPP_APIURL) === 0;

          if ((err.status === 401 || err.status === 403) && !isNppApiRequest) {
            // console.error('prima chiamata error testo la seconda');
            // next.handle(req).pipe(
            //   catchError(errBis => {
            //     console.error({ errBis });
            //     localStorage.removeItem(CostantiStorage.TOKEN);
            //     this.router.navigate(['login']);
            //     const error = err.error.message || err.statusText;
            //     return throwError(error);
            //   })
            // );
            // window.location.href = environment.baseUrlServizi + 'login';
            if (req.url.indexOf('oauth/authorize') >= 0) {
              const body = req.body;
              console.log(body);
              let params = `${body.response_type},${body.client_id},${body.redirect_uri},${body.scope}`;
              if (body.state !== undefined && body.state !== null) {
                params += `,${body.state}`;
              }
              window.location.href =
                environment.baseUrlServizi + `login?pagina=oauth_autorize&params=${encodeURIComponent(params)}`;
            } else {
              if (
                window.location.href !== environment.baseUrlServizi + 'login' &&
                window.location.href !== environment.baseUrlServizi + 'logout'
              ) {
                localStorage.setItem(CostantiStorage.URLPRELOGOUT, window.location.href);
              }

              window.location.href = environment.baseUrlServizi + 'login';
            }
          }
          const error = err.error?.message || err.statusText;
          return throwError(() => error);
        }
        return throwError(() => err);
      })
    );
  }
}
